import React from 'react';
import Title from '../../Components/Formatting/Customer/Title';
import Subtitle from '../../Components/Formatting/Customer/Subtitle';
import Services from '../../Components/Formatting/Services';
import DateTime from '../../Components/Formatting/DateTime';
import Dropdown from '../../Components/Dropdown';
import { classNames, getEntityLink } from '../../Services/helpers';
import { Transition } from '@headlessui/react'
import Badge from '../../Components/Badge/Badge';
import { statuses } from '../../Data/Jobs';
import { SelectBox, useSelectable } from '../../Components/Selectable';

const Job = ({job, setScheduling, setMarkingJobAsDone, setOpenJob}) => {
    const {isSelecting, toggleSelected} = useSelectable();

    // Clicking the full row should toggle, but we don't want to click the checkbox/dropdown area when not selecting
    const onClick = (isFullRowClick) => {
        if (isSelecting && isFullRowClick) {
            toggleSelected(`${job.customerId}-${job.id}`);
        } else if (isFullRowClick === false && isSelecting === false) {
            setScheduling(job);
        }
    }

    return <li className="flex items-center justify-between gap-x-4 py-3" onClick={() => onClick(true)}>
        <Transition
            show={isSelecting}
            enter="transition-[max-width] transition-opacity duration-150"
            enterFrom="opacity-0 max-w-[0px]"
            enterTo="opacity-100 max-w-[100px]"
            leave="transition-[max-width] transition-opacity duration-150"
            leaveFrom="opacity-100 max-w-[100px]"
            leaveTo="opacity-0 max-w-[0px]"
        >
            <div className={"flex flex-none items-center px-4"}>
                <SelectBox id={`${job.customerId}-${job.id}`} />
            </div>
        </Transition>
        <div className="grow" onClick={() => onClick(false)}>
            <p className="text-sm leading-6 text-gray-900 font-semibold">
                {job.title ?? '#'+job.shortId}
                <Badge className={classNames(statuses[job.status].bgColor, statuses[job.status].contrastTextColor, 'ml-4')}
                    title={job.status}
                />
            </p>
            <p className="pb-2">
                <span className="font-bold"><Title customer={job.customer} /></span><br />
                <Subtitle customer={job.customer} />
            </p>
            <p>{job.title ?? <Services services={job.services} />}</p>
            <p className="mt-2 text-muted"><DateTime date={job.scheduledDate} hideTime blank="Not scheduled" /></p>
        </div>
        <Transition
            show={!isSelecting}
            enter="transition-[max-width] transition-opacity duration-150"
            enterFrom="opacity-0 max-w-[0px]"
            enterTo="opacity-100 max-w-[100px]"
            leave="transition-[max-width] transition-opacity duration-150"
            leaveFrom="opacity-100 max-w-[100px]"
            leaveTo="opacity-0 max-w-[0px]"
        >
            <div className="shrink-0">
                <Dropdown options={[
                    {title: 'View customer', icon: 'User', to: getEntityLink('Customers/Customer', job.customerId, {_back: window.location.pathname})},
                    {title: 'View Job', icon: 'Truck', onClick: () => setOpenJob(job)},
                    {div: true},
                    {title: 'Schedule job', icon: 'CalendarPlus', onClick: () => setScheduling(job)},
                    {title: 'Mark as done', icon: 'Check', onClick: () => setMarkingJobAsDone(job)},
                ]} />
            </div>
        </Transition>
    </li>
}

export default Job;